// extracted by mini-css-extract-plugin
export default {"card":"ViewReport_card__Z6g+i"};